export default "__VITE_ASSET__DPafaRZZ__"